module.exports = __webpack_public_path__ + "img/partner_img.e839d39c.jpg";